export class UserIdentityEntity {
  id;
  email;
  userName;
  phoneNumber;
  userToPlatforms;
  constructor(id, email, userName, phoneNumber,userToPlatforms) {
    this.id = id;
    this.email = email;
    this.userName = userName;
    this.phoneNumber = phoneNumber;
    this.userToPlatforms = userToPlatforms;
  }
}
